import type { IConfigProps } from '../context/ConfigContext';

const getPrimaryAccountNumber = (topConfigContext: IConfigProps | undefined): string => {
    const customerIdList = topConfigContext?.user.getActiveUser().customerIdList;
    if (typeof customerIdList === 'string') {
        return customerIdList.split(',')[0];
    } else if (Array.isArray(customerIdList) && customerIdList.length > 0) {
        return customerIdList[0];
    }
    return '';
};

export { getPrimaryAccountNumber };
